export default "__VITE_ASSET__7da57daa__"